import Vue from "vue";

import { BootstrapVue } from "bootstrap-vue";

Vue.use(BootstrapVue);

require("./form-validation");

Vue.component('college-storage-view', require('./CollegeStorage/CollegeStorageView.vue').default);
Vue.component('upcoming-deadline-block', require('./Landing/UpcomingDeadlineBlock.vue').default);
Vue.component('storage-deadline-modal', require('js/UI/Landing/StorageDeadlineModal.vue').default);
Vue.component('uchicago-summer-modal', require('js/UI/Landing/UChicagoSummerModal.vue').default);

Vue.component('landing-page-video-section-tabs', require('js/UI/Landing/VideoSectionTabs.vue').default);
Vue.component('student-vaults-my-stuff-options', require('./StudentVaults/MyStuffOptions.vue').default);
Vue.component('uchicago-upcoming-deliveries', require('./StudentVaults/UpcomingDeliveriesModal.vue').default);

Vue.component('bc-widgets-payment-method', require('@/UI/widgets/PaymentMethodWidget.vue').default);
Vue.component('bc-widgets-server-side-address-input', require('@/UI/widgets/ServerSideAddressInputWidget.vue').default);
Vue.component('bc-widgets-client-side-address-input', require('@/UI/widgets/ClientSideAddressInputWidget.vue').default);

Vue.component('bc-sandbox-checkout-page', require('@/UI/Sandbox/CheckoutPage.vue').default);
